import { render, staticRenderFns } from "./realVoicePay.vue?vue&type=template&id=31bf1892&scoped=true&"
import script from "./realVoicePay.ts?vue&type=script&lang=js&"
export * from "./realVoicePay.ts?vue&type=script&lang=js&"
import style0 from "./realVoicePay.less?vue&type=style&index=0&id=31bf1892&lang=less&scoped=true&"
import style1 from "./realVoicePay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf1892",
  null
  
)

export default component.exports